import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import SetupWizard from "./setupWizard";
import RetentionDashboard from "../retentionDashboard/RetentionDashboard";

// The admin "Data" menu. Tab 0 = the existing data-export wizard (unchanged),
// Tab 1 = semester retention analytics. Deep-linkable via ?tab=retention.
const DataPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const initialTab = searchParams.get("tab") === "retention" ? 1 : 0;
    const [tab, setTab] = useState(initialTab);

    const handleChange = (_, value) => {
        setTab(value);
        setSearchParams(value === 1 ? { tab: "retention" } : {}, { replace: true });
    };

    return (
        <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider", px: 3, pt: 2 }}>
                <Tabs value={tab} onChange={handleChange} aria-label="data tabs">
                    <Tab label="Data Export" />
                    <Tab label="Retention Analytics" />
                </Tabs>
            </Box>
            {/* Mount lazily so retention data is only fetched when its tab is opened. */}
            {tab === 0 && <SetupWizard />}
            {tab === 1 && <RetentionDashboard />}
        </Box>
    );
};

export default DataPage;
